<template>
    <div @click="onClick(item.line1)">
        <div class="card mb-6 rounded-xl">
            <!-- <div class="campaign-image rounded-xl" :style="{ 'background-image': `url('${item.imageUrl}')` }"></div>
            <div
                class="label absolute -bottom-3 right-6 h-7 w-40 text-center text-base text-white py-2px"
            >{{ item.line1 }}</div> -->
            <div class="campaign-image rounded-xl relative" :style="{ 'background-image': `url('${item.imageUrl}')` }">
                <div class="absolute text-center text-xl text-white position-text" >
                    {{ item.line1 }}
                </div>
            </div>
            <!-- <div class="absolute text-center text-base text-black py-2px test">
                    Thailand
                </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchPromotionSubCatogaryItem",
    props: {
        item: {
            type: Object
        }
    },
    methods: {
        onClick: function (cateName) {
            // if (this.item.cat == null) return

            // this.$router.push({
            //     name: 'promotion-search-campaigns',
            //     params: {
            //         cat: this.item.cat
            //     }
            // })
            if (this.item.line2 == null) return
            this.tracking.event('sub_category', 'click_sub_category', cateName, null);
            window.open(this.item.line2);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/image.scss";

.card {
    object-fit: contain;
    // box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }

    img {
        margin: auto;
    }

    .campaign-image {
        @include boxRatio($ratio: 33.33%);
        // background-image: url("~@/assets/img/bg-searchpromotion.png");
        background-size: 100%;

        .position-text{
            top: 40%;
            left: 40%;
        }
    }
}
</style>
